import React from 'react';
import LogoTicker from './LogoTicker';

// Homepage trust band — Brand Story clients, placed right after the hero.
const TrustedBy = () => <LogoTicker category="all" heading="Trusted By Brands & Teams" gold />;

export default TrustedBy;
